var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5459 27.954C29.7572 28.1654 29.876 28.452 29.876 28.7509C29.876 29.0498 29.7572 29.3364 29.5459 29.5478C29.3346 29.7591 29.0479 29.8779 28.749 29.8779C28.4501 29.8779 28.1635 29.7591 27.9521 29.5478L22 23.5937L16.0459 29.5459C15.8346 29.7573 15.5479 29.876 15.249 29.876C14.9501 29.876 14.6635 29.7573 14.4521 29.5459C14.2408 29.3346 14.1221 29.0479 14.1221 28.749C14.1221 28.4502 14.2408 28.1635 14.4521 27.9522L20.4062 22L14.454 16.0459C14.2427 15.8346 14.1239 15.5479 14.1239 15.249C14.1239 14.9502 14.2427 14.6635 14.454 14.4522C14.6654 14.2408 14.952 14.1221 15.2509 14.1221C15.5498 14.1221 15.8364 14.2408 16.0478 14.4522L22 20.4062L27.954 14.4512C28.1654 14.2399 28.452 14.1212 28.7509 14.1212C29.0498 14.1212 29.3364 14.2399 29.5478 14.4512C29.7591 14.6626 29.8778 14.9492 29.8778 15.2481C29.8778 15.547 29.7591 15.8336 29.5478 16.045L23.5937 22L29.5459 27.954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightBox);
export default __webpack_public_path__ + "static/media/closeLightBox.5afded8ba39b061a4cd76171aa42759d.svg";
export { ForwardRef as ReactComponent };